import {
  START_LOADING,
  END_LOADING,
  FETCH_RENTALS,
  FETCH_RENTAL,
  FETCH_UNPAID_RENTALS,
  ADD_RENTAL,
  UPDATE_RENTAL,
  DELETE_RENTAL,
} from "../actions/constants";

const rentals = (
  state = { isLoading: false, rentals: [], rental: null },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_RENTALS:
      return {
        ...state,
        rentals: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_UNPAID_RENTALS:
      return {
        ...state,
        rentals: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_RENTAL:
      return { 
        ...state, 
        rental: action.payload.data,
        // Update the rental in the rentals array if it exists
        rentals: state.rentals.map((item) => 
          item.rental && item.rental._id === action.payload.data._id 
            ? { ...item, rental: action.payload.data } 
            : item
        )
      };
    case ADD_RENTAL:
      return { ...state, rentals: [...state.rentals, action.payload] };
    case UPDATE_RENTAL:
      return {
        ...state,
        rentals: state.rentals.map((rental) =>
          rental._id === action.payload._id ? action.payload : rental
        ),
      };
    case DELETE_RENTAL:
      return {
        ...state,
        rentals: state.rentals.filter(
          (rental) => rental._id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default rentals;
